
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Selector from 'vux/src/components/selector/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import common from '@/tools/common'
import vSelect from './vselect'
export default {
directives: {
TransferDom
},
components: {
vSelect,
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
XTable,
Popup,
Selector,
Alert,
Datetime,
XDialog
},
methods: {
ToggleTitle () {
if (this.toggle === true) {
this.toggle = false
} else {
this.toggle = true
}
},
async ChangePdfScale () {

},
async char2buf (str) {
var out = new ArrayBuffer(str.length)
var u16a = new Uint8Array(out)
var strs = str.split('')
for (var i = 0; i < strs.length; i++) {
u16a[i] = strs[i].charCodeAt()
}
return u16a
},
async showPdf () {
let url = this.$http.defaults.baseURL + '/API/FoodsRules/GetRuleContent?ticket=' + this.ticket + '&token=' + this.token + '&guid=' + this.$route.query.guid
this.fileUrl = encodeURIComponent(url)
}
},
data () {
return {
queryResult: {Data: [], TotalPage: 0},
queryMessage: '',
replacetext: '',
replaceOldText: '',
ruleinfotext: '',
ruleinfoOldeText: '',
currentItem: null,
ticket: '',
token: '',
toggle: true,
pSrc: '',
totalPageArray: 0,
z_totalPage: [],
src: '',
pdfscale: 0.6,
fileUrl: '',
filetypes: 1
}
},
beforeCreate: function () {
this.querydata = common.getPower()
this.filetypes = this.$route.query.filetypes
let ss = common.getfoodSession()
if (ss && ss.length > 8) {
} else {
this.$router.push({name: 'FoodRulesLoginPage', query: {UserType: 'type8'}})
}
},
async activated () {


this.ticket = this.$route.query.ticket
this.token = this.$route.query.token
const queryPromise = await this.$http.get('/API/FoodsRules/GetOneRule', {params: this.$route.query})
this.currentItem = queryPromise.data.Data
if (queryPromise.data.Token !== this.token) {
this.token = queryPromise.data.Token
}
this.showPdf()



}
}



// WEBPACK FOOTER //
// ./src/components/FoodRulesSearchDetails.vue